/**
 * Clamped toggle
 *
 * This script is used to toggle the visibility of a clamped description.
 *
 * Example Usage:
 * Since the HTML for this is in `shared/clamped_text.html.erb`, it can be used like:
 * <%= render 'shared/clamped_text', description: 'This is a long description that will be clamped.' %>
 */
function checkOverflow(): void {
  document
    .querySelectorAll<HTMLElement>('[data-clamped-wrapper]')
    .forEach((wrapper) => {
      const description =
        wrapper.querySelector<HTMLElement>('[data-clamppable]');
      const button = wrapper.querySelector<HTMLButtonElement>(
        '[data-clamp-toggle]',
      );
      if (description && button) {
        if (description.scrollHeight > description.clientHeight) {
          button.classList.remove('btn-toggle--hide');
        } else {
          button.classList.add('btn-toggle--hide');
        }
      }
    });
}
window.addEventListener('resize', checkOverflow);
document
  .querySelectorAll<HTMLElement>('[data-clamped-wrapper]')
  .forEach((wrapper) => {
    const button = wrapper.querySelector<HTMLButtonElement>(
      '[data-clamp-toggle]',
    );
    if (button) {
      button.addEventListener('click', function () {
        const description =
          wrapper.querySelector<HTMLElement>('[data-clamppable]');
        if (description) {
          description.classList.toggle('unclamp');
          this.textContent = description.classList.contains('unclamp')
            ? (this.dataset.hide ?? '')
            : (this.dataset.show ?? '');
        }
      });
    }
  });
checkOverflow();
